import React from 'react'
import styled from '@emotion/styled'

import { highlightBlueBase, highlightBlueDark30, highlightBlueDark10, grayDark40, black, grayLight10, white, grayLightB5, highlightBlueLightSelected } from '../../constants/principles'
import { fontSizeSmall, fontSize3XSmall, fontSize2XSmall } from '../../constants/principles'
import { breakpoints } from '../../constants'
import { BrowserUtils } from '../../utils/siteUtils'

import CarFrontImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Car_Front.svg'
import CarDriverImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Car_Driver.svg'
import CarRearImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Car_Rear.svg'
import CarPassengerImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Car_Passenger.svg'
import WindowLightImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Window_Lights.svg'

import JeepFrontImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Jeep_Front.svg'
import JeepDriverImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Jeep_Driver.svg'
import JeepPassengerImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Jeep_Passanger.svg'
import JeepRearImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Jeep_Rear.svg'
import SUVFrontImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_SUV_Front.svg'
import SUVPassengerImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_SUV_Passenger.svg'
import SUVDriverImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_SUV_Driver.svg'
import SUVRearImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_SUV Rear.svg'
import TruckFrontImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Truck_Front.svg'
import TruckDriverImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Truck_Driver.svg'
import TruckPassengerImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Truck_Passanger.svg'
import TruckRearImage from '../../assets/Condition/Svgs/Exterior/ICO_Tab_Vehicle_Icons_Truck_Rear.svg'

import Seats from '../../assets/Condition/Svgs/Interior/Seats.svg'
import DashLights from '../../assets/Condition/Svgs/Interior/Dashlights.svg'
import TabArrow from '../../assets/Condition/Svgs/Common/ICO_Tab_Vehicle_Icons_Triangle.svg'

export default ({ onClick, label, isActive, isImage, displayArrow, tabPrimary, bodyStyle, make, model, count, testId }) => {
  const isDesktop = BrowserUtils.isDesktop()
  return (
    <>
      {/* this is for the first page (vin and lisence plate) */}
      {!isImage && !displayArrow && (
        <StyledLi data-testid={testId} isActive={isActive} onClick={onClick}>
          <div> {label}</div>
          <StyledSpan>{label}</StyledSpan>
        </StyledLi>
      )}
      {/* this is for condition primary (Exterior, Interior, Mechanical) */}
      {!isImage && displayArrow && (
        <>
          <StyledLiForPrimaryNavigation data-testid={testId} isActive={isActive} onClick={onClick} isDesktop={isDesktop} labelName={label}>
            {label}
            {isActive && <StyledArrowWrapper label={label}>{<StyledArrow src={TabArrow} alt={label}></StyledArrow>}</StyledArrowWrapper>}
          </StyledLiForPrimaryNavigation>
        </>
      )}
      {/* this is for condition secondary (front, driver, Rear...etc) */}
      {isImage && (
        <StyledLiForSecondaryCondition data-testid={testId} label={label} isActive={isActive} onClick={onClick} count={count} isDesktop={isDesktop}>
          <TabImages image={label} isActive={isActive} tabPrimary={tabPrimary} isDesktop={isDesktop} bodyStyle={bodyStyle} make={make} model={model}></TabImages>
        </StyledLiForSecondaryCondition>
      )}
    </>
  )
}

const returnImage = function(image) {
  let vehType = returnVehType(image)

  if (vehType !== undefined && image.make !== undefined) {
    if (vehType === 'car' && image.image.toLowerCase() === 'front') {
      return CarFrontImage
    }
    if (vehType === 'car' && image.image.toLowerCase() === 'driver') {
      return CarDriverImage
    }
    if (vehType === 'car' && image.image.toLowerCase() === 'rear') {
      return CarRearImage
    }
    if (vehType === 'car' && image.image.toLowerCase() === 'passenger') {
      return CarPassengerImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'front') {
      return SUVFrontImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'driver') {
      return SUVDriverImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'rear') {
      return SUVRearImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'passenger') {
      return SUVPassengerImage
    }
    if (vehType === 'truck' && image.image.toLowerCase() === 'front') {
      return TruckFrontImage
    }
    if (vehType === 'truck' && image.image.toLowerCase() === 'rear') {
      return TruckRearImage
    }
    if (vehType === 'truck' && image.image.toLowerCase() === 'driver') {
      return TruckDriverImage
    }
    if (vehType === 'truck' && image.image.toLowerCase() === 'passenger') {
      return TruckPassengerImage
    }
    if (vehType === 'jeep' && image.image.toLowerCase() === 'front') {
      return JeepFrontImage
    }
    if (vehType === 'jeep' && image.image.toLowerCase() === 'driver') {
      return JeepDriverImage
    }
    if (vehType === 'jeep' && image.image.toLowerCase() === 'rear') {
      return JeepRearImage
    }
    if (vehType === 'jeep' && image.image.toLowerCase() === 'passenger') {
      return JeepPassengerImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'front' && image.make.toLowerCase() === 'jeep' && image.model.toLowerCase() !== 'wrangler' && image.model.toLowerCase() !== 'gladiator') {
      return SUVFrontImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'driver' && image.make.toLowerCase() === 'jeep' && image.model.toLowerCase() !== 'wrangler' && image.model.toLowerCase() !== 'gladiator') {
      return SUVDriverImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'rear' && image.make.toLowerCase() === 'jeep' && image.model.toLowerCase() !== 'wrangler' && image.model.toLowerCase() !== 'gladiator') {
      return SUVRearImage
    }
    if (vehType === 'suv' && image.image.toLowerCase() === 'passenger' && image.make.toLowerCase() === 'jeep' && image.model.toLowerCase() !== 'wrangler' && image.model.toLowerCase() !== 'gladiator') {
      return SUVPassengerImage
    }
  }

  if (image.image.toLowerCase() === 'windows') {
    return WindowLightImage
  }
  if (image.image.toLowerCase() === 'seats') {
    return Seats
  }
  if (image.image.toLowerCase() === 'dashboard') {
    return DashLights
  }
}

//map bodyStyles and return a vehicle type
const returnVehType = image => {
  const bodyStyle = image.bodyStyle && image.bodyStyle.toLowerCase()
  if (image.bodyStyle) {
    const model = image.model.toLowerCase()
    const make = image.make.toLowerCase()

    const isWranglerOrGladitor = ['wrangler', 'gladiator'].includes(model)
    if (['convertible', 'coupe', 'hatchback', 'sedan', 'wagon'].includes(bodyStyle)) {
      return 'car'
    }
    if (['suv', 'van', 'cargo', 'sportutility', 'passenger'].includes(bodyStyle) && !isWranglerOrGladitor) {
      return 'suv'
    }
    if (bodyStyle === 'pickup' && make !== 'jeep') {
      return 'truck'
    }
    if (make === 'jeep' && isWranglerOrGladitor) {
      return 'jeep'
    }
  }
}

const returnText = function(text) {
  switch (text.toLowerCase()) {
    case 'driver':
      return 'Driver'
    case 'rear':
      return 'Rear'
    case 'passenger':
      return 'Passenger'
    case 'windows':
      return 'Windows/ Lights'
    case 'seats':
      return 'Seats, Carpet & Headliner'
    case 'dashboard':
      return 'Dashboard Lights'
    default:
      return 'Front'
  }
}

const TabImages = image => {
  return (
    <>
      {image.tabPrimary === 'Exterior' && (
        <IconExterior isActive={image.isActive} isDesktop={image.isDesktop}>
          <StyledImgExterior isActive={image.isActive} src={returnImage(image)} alt="image"></StyledImgExterior>
          <div className="icon-text-exterior">{returnText(image.image)}</div>
        </IconExterior>
      )}
      {image.tabPrimary === 'Interior' && (
        <IconInterior isActive={image.isActive} isDesktop={image.isDesktop}>
          <StyledImgInterior isActive={image.isActive} src={returnImage(image)} alt="image"></StyledImgInterior>
          <div className="icon-text">{returnText(image.image)}</div>
        </IconInterior>
      )}
    </>
  )
}

const StyledLi = styled.li`
  display: inline-block;
  list-style: none;
  padding: 0 4px;
  @media (min-width: ${breakpoints.sm}px) {
    padding: 0 8px;
  }
  height: 32px;
  margin: 0 8px;
  color: ${black};
  font-size: ${fontSize2XSmall};
  &:hover {
    color: ${highlightBlueBase};
  }
  &:active {
    ${highlightBlueDark30};
  }
  &:focus {
    color: ${highlightBlueBase};
  }

  ${p =>
    p.isActive &&
    `
  border-bottom: 4px solid ${highlightBlueBase};
  font-weight: bold;
  color: ${grayDark40};
`}
`

const StyledLiForPrimaryNavigation = styled.li`
  color: ${p => (p.isActive ? white : grayLightB5)};
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;

  &:first-child {
    width: ${p => (!p.isDesktop ? '25%' : '33%')};
  }

  height: 32px;
  font-size: ${fontSizeSmall};

  &:hover {
    color: ${p => (p.isActive ? white : highlightBlueDark10)};
    background-color: ${p => (p.isActive ? highlightBlueDark10 : white)};
    border-bottom: 1px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
    border-top: 1px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
    border-left: 1px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
    border-right: 0px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
  }
  background-color: ${p => (p.isActive ? highlightBlueDark10 : white)};
  border-bottom: 1px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
  border-top: 1px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
  border-left: 1px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
  border-right: 0px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};

  &:last-child {
    border-right: 1px solid ${p => (p.isActive ? highlightBlueDark10 : grayLightB5)};
  }
`

export const StyledLiForPrimaryNavigationLabelDiv = styled.div`
  color: ${p => (p.isActive ? { highlightBlueBase } : { grayLight10 })};
  font-weight: bold;
`

const StyledLiForSecondaryCondition = styled.li`
  display: flex;
  list-style: none;
  padding: ${p => (p.isDesktop ? '0 4px' : '0 2px')};
  height: 98px;
  font-size: ${fontSize2XSmall};

  &::after {
  min-height: 16px;
  background: #559c56;
  border-radius: 50%;
  color: #fff;
  content: '${p => p.count}';
  margin-left: ${p => (p.label === 'Seats' || p.label === 'Dashboard' ? (p.isDesktop ? '165px' : '155px') : p.isDesktop ? '80px' : '50px')};
  font-size: ${fontSize3XSmall};
  min-width: 20px;
  position: absolute;
  text-align: center;
  border-width: 1px;
  border-color: #808080;
  border-style: solid;
  opacity: ${p => (p.count > 0 ? 1 : 0)};
  font-weight: 700;
  }

  &:last-child {
    .icon-text-exterior {
      margin-top: ${p => (p.isDesktop ? '-17px;' : '-5px')};
      @media (min-width: ${breakpoints.highmed}px) {
      margin-top: -17px;
    }
  }
  
  }
`
const StyledSpan = styled.span`
  display: block;
  font-weight: bold;
  height: 1px;
  color: transparent;
  overflow: hidden;
  visibility: hidden;
`
const IconExterior = styled.div`
  height: 95px;
  padding: 1px;
  padding: 1px;
  width: ${p => (p.isDesktop ? '95px' : '65px')};
  border: solid 1px #808080;
  border-radius: 7px;
  .icon-text {
    font-size: ${p => (p.isDesktop ? '13px' : '11px')};
    padding: 0 1px;
    word-wrap: break-word;
    font-weight: bold;
    opacity: 0.5;
    ${p =>
      p.isActive &&
      `
    opacity: 1;
`}
  }

  .icon-text-exterior {
    font-size: ${p => (p.isDesktop ? '13px' : '11px')};
    padding: 0 1px;
    word-wrap: break-word;
    font-weight: bold;
    opacity: 0.5;
    margin-top: ${p => (p.isDesktop ? '-10px;' : '-5px')};
    @media (min-width: ${breakpoints.highmed}px) {
      margin-top: -10px;
    }

    ${p =>
      p.isActive &&
      `
    opacity: 1;  
`}
  }

  &:active {
    ${highlightBlueDark30};
  }
  ${p =>
    p.isActive &&
    `
  border-bottom: 7px solid ${highlightBlueDark10};
  color: ${grayDark40};
`}
`

const StyledImgExterior = styled.img`
  height: 50px;
  @media (min-width: ${breakpoints.highmed}px) {
    height: 65px;
  }

  opacity: 0.5;
  ${p =>
    p.isActive &&
    `
  opacity: 1;
`}
`

const IconInterior = styled.div`
  height: 109px;
  padding: 1px;
  padding-top: 15px;
  width: ${p => (p.isDesktop ? '180px' : '170px')};
  border: solid 1px #808080;
  border-radius: 7px;
  .icon-text {
    font-size: 13px;
    word-wrap: break-word;
    font-weight: bold;
    padding-top: 13px;
    opacity: 0.5;
    ${p =>
      p.isActive &&
      `
    opacity: 1;
`}
  }
  &:active {
    ${highlightBlueDark30};
  }
  ${p =>
    p.isActive &&
    `
  border-bottom: 7px solid ${highlightBlueDark10};
  color: ${grayDark40};
`}
`
const StyledImgInterior = styled.img`
  height: 35px;
  opacity: 0.3;
  ${p =>
    p.isActive &&
    `
  opacity: 1;
`}
`
export const IconGroup = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 8px;
`
const StyledArrow = styled.img`
  margin-top: -27px;
  width: 50px;
`
const StyledArrowWrapper = styled.div`
  width: ${p => (p.label === 'Mechanical' ? '114px' : '80px')};
  margin-top: 0px;
`
